import { StateCreator } from 'zustand';
import { ImagePreviewSlice } from './index.types';

export const createImagePreviewSlice: StateCreator<ImagePreviewSlice> = (set) => ({
  isImagePreviewOpen: null,
  setImagePreviewOpen: (id) =>
    set((state) => ({ ...state, isImagePreviewOpen: id })),
});